var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftSideArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7535 9.30891H1.89477C1.20618 9.30891 0.64823 8.72305 0.64823 8.00001C0.64823 7.27698 1.20618 6.69111 1.89477 6.69111H16.7535C17.4421 6.69111 18 7.27698 18 8.00001C18 8.72305 17.4421 9.30891 16.7535 9.30891Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6034 15.5C7.30024 15.5 6.99609 15.3843 6.75625 15.1508L0.398923 8.95969C0.142635 8.70996 -0.00246146 8.35865 3.16065e-05 7.99111C0.00252468 7.6241 0.15161 7.27436 0.411388 7.02829L6.94323 0.837197C7.45431 0.352905 8.24262 0.395313 8.70384 0.931961C9.16506 1.46861 9.12467 2.29636 8.61359 2.78065L3.09293 8.0131L8.45154 13.2314C8.95614 13.723 8.98606 14.5513 8.51786 15.0812C8.27204 15.3592 7.93847 15.5 7.6034 15.5Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSideArrowIcon);
export default __webpack_public_path__ + "static/media/LeftSideArrowIcon.0aaf7cee5dde46560982f2462f294371.svg";
export { ForwardRef as ReactComponent };